import React, { useEffect, useMemo, useState } from "react";
import { FiPlus, FiEdit2, FiTrash2 } from "react-icons/fi";
import { Modal, Card, Tooltip, Input, message } from "antd";
import JoditEditor from "jodit-react";
import { useParams } from "react-router-dom";
import Instance from "../../../AxiosConfig";

const { TextArea } = Input;

export const Content = () => {
  const { id: companyId } = useParams();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [title, setTitle] = useState("");
  const [editorContent, setEditorContent] = useState("");

  const [notes, setNotes] = useState([]);
  const [editId, setEditId] = useState(null);

  // Jodit Config
  const config = useMemo(
    () => ({
      readonly: false,
      placeholder: "Start writing...",
      height: 450,
      showCharsCounter: false,
      showWordsCounter: false,
      showXPathInStatusbar: false,
      toolbarAdaptive: false,
      statusbar: false,
    }),
    []
  );

  // ================= FETCH NOTES =================
  const fetchNotes = async () => {
    try {
      const res = await Instance.get(
        `/company/${companyId}/contents`
      );
console.log("Fetched Notes:", res.data);
      setNotes(res.data?.contents || []);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchNotes();
  }, []);

  // ================= OPEN ADD MODAL =================
  const openAddModal = () => {
    setTitle("");
    setEditorContent("");
    setEditId(null);
    setIsModalOpen(true);
  };

  // ================= SAVE NOTE =================
  const handleSave = async () => {
    if (!title.trim()) {
      return message.error("Please enter title");
    }

    if (!editorContent.trim()) {
      return message.error("Please enter content");
    }

    const payload = {
      title: title,
      content: editorContent,
    };

    try {
      // EDIT
      if (editId) {
        await Instance.put(
          `/company/${companyId}/contents/${editId}`,
          payload
        );

        message.success("Note updated successfully");
      } else {
        // ADD
        await Instance.post(
          `/company/${companyId}/contents`,
          payload
        );

        message.success("Note added successfully");
      }

      fetchNotes();

      setIsModalOpen(false);
      setTitle("");
      setEditorContent("");
      setEditId(null);
    } catch (error) {
      console.log(error);
      message.error("Something went wrong");
    }
  };

  // ================= EDIT NOTE =================
  const handleEdit = (note) => {
    setTitle(note.title);
    setEditorContent(note.content);
    setEditId(note._id);

    setIsModalOpen(true);
  };

  // ================= DELETE NOTE =================
  const handleDelete = async (id) => {
    try {
      await Instance.delete(
        `/company/${companyId}/contents/${id}`
      );

      message.success("Note deleted successfully");

      fetchNotes();
    } catch (error) {
      console.log(error);
      message.error("Delete failed");
    }
  };

  return (
    <div>
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center my-4">
        <h2 className="proforma-title">Notes</h2>

        <button
          className="add-certification-btn"
          onClick={openAddModal}
          style={{
            backgroundColor: "#1890ff",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            padding: "8px 18px",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          <FiPlus /> Add Notes
        </button>
      </div>

      {/* Notes List */}
      <div className="row">
        {notes?.map((note) => (
          <div className="col-md-12 mb-4" key={note.id}>
            <Card
              style={{
                borderRadius: "12px",
                boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
              }}
              bodyStyle={{ padding: "18px" }}
            >
              {/* Top Section */}
              {/* Top Section */}
<div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "14px",
  }}
>
  {/* Left Side */}
  <div>
    {/* Created Date */}
    <p
      style={{
        margin: 0,
        fontSize: "18px",
        color: "#000",
        marginBottom: "4px",
      }}
    >
      {new Date(note.createdAt).toLocaleString()}
    </p>

    {/* Title */}
    <h4
      style={{
        margin: 0,
        fontWeight: 600,
      }}
    >
      {note.title}
    </h4>
  </div>

  {/* Icons */}
  <div
    style={{
      display: "flex",
      gap: "14px",
    }}
  >
    <Tooltip title="Edit">
      <FiEdit2
        size={18}
        style={{
          cursor: "pointer",
          color: "#1890ff",
        }}
        onClick={() => handleEdit(note)}
      />
    </Tooltip>

    <Tooltip title="Delete">
      <FiTrash2
        size={18}
        style={{
          cursor: "pointer",
          color: "red",
        }}
        onClick={() => handleDelete(note._id)}
      />
    </Tooltip>
  </div>
</div>

              {/* Content */}
              <div
                dangerouslySetInnerHTML={{
                  __html: note.content,
                }}
                style={{
                  maxHeight: "300px",
                  overflowY: "auto",
                }}
              />
            </Card>
          </div>
        ))}
      </div>

      {/* Modal */}
      <Modal
        title={editId ? "Edit Note" : "Add Note"}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width={950}
        centered
      >
        {/* Title Input */}
        <div style={{ marginBottom: "16px" }}>
          <label
            style={{
              display: "block",
              marginBottom: "6px",
              fontWeight: 500,
            }}
          >
            Title
          </label>

          <Input
            placeholder="Enter title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            size="large"
          />
        </div>

        {/* Editor */}
        <JoditEditor
          value={editorContent}
          config={config}
          onChange={(newContent) => setEditorContent(newContent)}
        />

        {/* Footer Buttons */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "12px",
            marginTop: "20px",
          }}
        >
          <button
            onClick={() => setIsModalOpen(false)}
            style={{
              border: "1px solid #d9d9d9",
              background: "#fff",
              padding: "8px 18px",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>

          <button
            onClick={handleSave}
            style={{
              background: "#1677ff",
              color: "#fff",
              border: "none",
              padding: "8px 20px",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            {editId ? "Update" : "Save"}
          </button>
        </div>
      </Modal>
    </div>
  );
};